import React, { useEffect } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { Card, CircuitPattern } from '../components/common';
import { BRAND_LOGO_FULL_SRC } from '../config/brandAssets';
import { savePostAuthIntentFromQueryValue } from '../utils/postAuthIntent';

const RegisterChoicePage: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const roleParam = String(params.get('role') || params.get('type') || '')
    .trim()
    .toLowerCase();
  const postAuthIntent = params.get('postAuthIntent');

  useEffect(() => {
    if (!postAuthIntent) {
      return;
    }
    savePostAuthIntentFromQueryValue(postAuthIntent, 'register-choice-query');
  }, [postAuthIntent]);

  const registerClientTarget = postAuthIntent
    ? `/register/client?postAuthIntent=${postAuthIntent}`
    : '/register/client';
  const registerServiceTarget = postAuthIntent
    ? `/register/service?postAuthIntent=${postAuthIntent}`
    : '/register/service';
  const loginTarget = postAuthIntent ? `/login?postAuthIntent=${postAuthIntent}` : '/login';

  if (roleParam === 'service' || roleParam === 'serviceadmin') {
    return <Navigate to={registerServiceTarget} state={location.state} replace />;
  }

  if (roleParam === 'client') {
    return <Navigate to={registerClientTarget} state={location.state} replace />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-primary-dark-100">
      <div className="absolute inset-0 pointer-events-none">
        <CircuitPattern opacity={0.03} />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-dark-100/0 via-primary-dark-100/80 to-primary-dark-100"></div>
      </div>

      <div className="relative z-10 flex-1 flex items-center justify-center px-4 py-12">
        <Card className="w-full max-w-md p-8 shadow-lg border-primary-dark-300/70 animate-slide-up">
          <div className="mb-8 text-center">
            <Link to="/" className="inline-block group focus-outline rounded-md">
              <img
                src={BRAND_LOGO_FULL_SRC}
                alt="Ratuj Sprzęt Logo"
                className="w-16 h-16 mb-2 mx-auto group-hover:opacity-90 transition-opacity"
              />
              <h1 className="text-2xl font-display font-bold text-primary-light-100 group-hover:text-primary-light-200 transition-colors">
                Ratuj Sprzęt
              </h1>
            </Link>
          </div>

          <h2 className="text-xl font-bold text-primary-light-100 mb-2 text-center">
            Wybierz ścieżkę rejestracji
          </h2>
          <p className="text-sm text-primary-light-300 text-center mb-6">
            Załóż konto klienta albo dołącz jako serwis.
          </p>

          <div className="space-y-3">
            <Link
              to={registerClientTarget}
              state={location.state}
              className="block w-full rounded-lg bg-ratuj-300 px-4 py-3 text-center font-medium text-primary-dark-100 hover:bg-ratuj-400 transition-colors"
            >
              Załóż konto klienta
            </Link>
            <Link
              to={registerServiceTarget}
              state={location.state}
              className="block w-full rounded-lg bg-gold-300 px-4 py-3 text-center font-medium text-primary-dark-100 hover:bg-gold-400 transition-colors"
            >
              Dołącz jako serwis
            </Link>
          </div>

          <p className="mt-6 text-center text-sm text-primary-light-300">
            Masz już konto?{' '}
            <Link
              to={loginTarget}
              state={location.state}
              className="text-ratuj-300 hover:text-ratuj-200 font-medium focus-outline rounded"
            >
              Zaloguj się
            </Link>
          </p>
        </Card>
      </div>
    </div>
  );
};

export default RegisterChoicePage;
